// src/services/adminAdministrateurs.js
//
// Domaine Admin — Administrateurs & niveaux d'autorité.
// Les fonctions RBAC (rôles / permissions) sont dans adminRolesPermissions.js
// et réexportées ici pour compatibilité des imports existants.

import { apiFetch } from './adminHttp';

export {
  getRoles,
  creerRole,
  getRolesAdministrateur,
  attribuerRole,
  attribuerRoleTemporaire,
  prolongerRole,
  revoquerRole,
  getPermissions,
  creerPermission,
  getPermissionsDuRole,
  attacherPermission,
  detacherPermission,
  getPermissionsEffectives,
} from './adminRolesPermissions';

/* ---------- Niveaux & comptes ---------- */

export async function getNiveauxAutorite() {
  return apiFetch('/admin/niveaux-autorite', {
    method: 'GET',
  });
}

export async function getAdministrateurs() {
  return apiFetch('/admin/administrateurs', {
    method: 'GET',
  });
}

export async function creerAdministrateur(payload) {
  return apiFetch('/admin/administrateurs', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function changerNiveauAdministrateur(administrateurId, niveauAutoriteId) {
  return apiFetch('/admin/administrateurs/niveau', {
    method: 'POST',
    body: JSON.stringify({
      administrateur_id: administrateurId,
      niveau_autorite_id: niveauAutoriteId,
    }),
  });
}

export async function changerStatutAdministrateur(administrateurId, statut) {
  return apiFetch('/admin/administrateurs/statut', {
    method: 'POST',
    body: JSON.stringify({ administrateur_id: administrateurId, statut }),
  });
}
